package com.essntl.features.currency.ui.addcurrency.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import com.essntl.core.settings.domain.model.configuration.ConfigurationCurrencyModel
import com.essntl.features.currency.ui.addcurrency.AddCurrencyEvent
import com.essntl.features.currency.ui.addcurrency.AddCurrencyScreen
import com.essntl.features.currency.ui.addcurrency.AddCurrencyState
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AddCurrencyDialog(
    openDialog: Boolean,
    configurationCurrency: ConfigurationCurrencyModel?,
    state: AddCurrencyState,
    onEvent: (AddCurrencyEvent) -> Unit,
    onDismissRequest: () -> Unit,
    modifier: Modifier = Modifier,
) {
    LaunchedEffect(openDialog) {
        if (openDialog) {
            onEvent(AddCurrencyEvent.ClearState)
            onEvent(AddCurrencyEvent.GetAllCurrencies)
            if (configurationCurrency != null)
                onEvent(AddCurrencyEvent.SetConfigurationCurrency(configurationCurrency))
        }
    }

    if (openDialog)
        BasicAlertDialog(
            onDismissRequest = onDismissRequest,
            properties = DialogProperties(usePlatformDefaultWidth = false),
            modifier = modifier
                .fillMaxWidth(0.3f)
                .fillMaxHeight(0.6f),
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(25.dp)),
            ) {
                Column(
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(color = Color.White),
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(color = MaterialTheme.esColorScheme.bgPrimary)
                            .padding(vertical = 3.spacing, horizontal = 2.5.spacing),
                    ) {
                        Text(
                            text = "Add new currency",
                            style = MaterialTheme.esTypography.h3Bold24,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            modifier = Modifier.align(Alignment.CenterStart),
                        )

                        EsSmallOutlineIconButton(
                            onClick = { onDismissRequest() },
                            iconRes = EsIcons.Close,
                            modifier = Modifier.align(Alignment.CenterEnd),
                        )
                    }

                    AddCurrencyScreen(
                        state = state,
                        onEvent = onEvent,
                    )
                }
            }
        }
}